import isNumber from './is-number';
var isPositive = function (num) {
    return isNumber(num) && num > 0;
};
export default isPositive;
//# sourceMappingURL=is-positive.js.map